// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.debug-chatbox[data-v-f12daeae] {\n\tposition: fixed;\n    width: 550px;\n\tbottom: 0;\n    right: 0;\n    z-index: 100;\n}\n.debug-chatbox .content[data-v-f12daeae] {\n\theight: 560px;\n    overflow-x: scroll;\n    overflow-x: hidden;\n\tposition: relative;\n    top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
